import { Link } from 'react-router-dom';
import type { HotItem } from '@/types/content';
import TrendBadge from '@/components/feature/TrendBadge';

interface HotRankRowProps {
  item: HotItem;
  rank: number;
}

const rankStyles: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-accent-500 text-primary-950',
  3: 'bg-secondary-500 text-background-50',
};

export default function HotRankRow({ item, rank }: HotRankRowProps) {
  const rankClass = rankStyles[rank] ?? 'bg-background-200 text-foreground-600';

  return (
    <Link
      to={`/article/${item.id}`}
      className="group flex items-center gap-3 rounded-lg border border-transparent px-2 py-3.5 transition-colors hover:border-background-200 hover:bg-background-100 md:gap-4 md:px-3"
    >
      <span
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold tabular-nums ${rankClass}`}
      >
        {rank}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
            {item.category}
          </span>
          <span className="text-[11px] text-foreground-400">{item.publishedAt}</span>
        </div>
        <h3 className="mt-1.5 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600 md:text-[15px]">
          {item.title}
        </h3>
      </div>
      <div className="hidden shrink-0 flex-col items-end gap-1.5 sm:flex">
        <span className="font-heading text-lg tabular-nums text-primary-600">{item.heat}</span>
        <TrendBadge trend={item.trend} value={item.trendValue} compact />
      </div>
      <i className="ri-arrow-right-s-line shrink-0 text-lg text-foreground-300 transition-all group-hover:translate-x-0.5 group-hover:text-primary-500" />
    </Link>
  );
}